import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { SupplierService } from '../../../../core/services/supplier.service';

@Component({
  selector: 'app-user-external',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatIconModule
  ],
  templateUrl: './user-external.component.html',
  styleUrl: './user-external.component.css'
})
export class UserExternalComponent {
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private supplierService = inject(SupplierService);

  loading = signal(false);
  errorMessage = signal<string | null>(null);
  submitted = signal(false);

  passportTypes = [
    { value: 'ID', label: 'ID' },
    { value: 'AN', label: 'AN' },
    { value: 'PN', label: 'PN' },
    { value: 'IK', label: 'IK' }
  ];

  form: FormGroup = this.fb.group({
    passportType: ['AN', Validators.required],
    passportNumber: ['', [Validators.required, Validators.pattern(/^\d{7}$/)]],
    consentPersonalData: [false, Validators.requiredTrue]
  });

  onPassportNumberInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, '').slice(0, 7);
    input.value = value;
    this.form.patchValue({ passportNumber: value });
  }

  submit(): void {
    this.submitted.set(true);
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { passportType, passportNumber, consentPersonalData } = this.form.value;
    this.loading.set(true);
    this.errorMessage.set(null);

    this.supplierService
      .registerExternalUser({
        consentPersonalData,
        passportNumber: `${passportType}${passportNumber}`
      })
      .subscribe({
        next: () => {
          this.loading.set(false);
          this.router.navigate(['/']);
        },
        error: (err) => {
          this.loading.set(false);
          const body = err?.error;
          this.errorMessage.set(body?.res?.ru || body?.msg || 'Произошла ошибка. Попробуйте ещё раз.');
        }
      });
  }
}
